import { useMutation, useQueryClient } from '@tanstack/react-query'
import Cookies from 'js-cookie'
import type { SavedSearchConfig } from '@/lib/saved-search'

// 保存済み検索クエリをすべて削除
export function useClearAllSearchQueries(config: SavedSearchConfig) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      Cookies.set(config.cookieKey, JSON.stringify([]), config.cookieOptions)
      return []
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: config.queryKey() })
    },
  })
}
